module.exports = __webpack_public_path__ + "img/12.8c6458bb.jpg";